import dayjs from 'dayjs';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';

import { AutocompleteV2, Icons, tokens } from '@cast/design-system';
import { DATE_MONTH_DAY_TIME } from '@cast/constants';

import { useInventoryWorkloadsTimeRangeSelection } from '../_hooks/useInventoryWorkloadsTimeRangeSelection';

dayjs.extend(utc);
dayjs.extend(timezone);

export const InventoryWorkloadsCurrentDate = () => {
  const { timeZone } = useInventoryWorkloadsTimeRangeSelection();
  const currentDate = dayjs().tz(timeZone).format(DATE_MONTH_DAY_TIME);

  return (
    <AutocompleteV2
      items={[currentDate]}
      value={currentDate}
      prefix={
        <Icons.CalendarBlank
          size={16}
          color={tokens.theme.fg.structural.secondary}
        />
      }
      readOnly
      size="small"
      testId="inventory-workloads-current-date"
    />
  );
};
